<template>
  <div class="mb-3">
    <h3 class="mb-1 text-lg font-bold">Scan Bookings</h3>
    <div class="flex h-[50px] items-center">
      <p class="w-1/3 text-base">Scan bookings</p>
      <div class="flex w-1/3 items-center gap-2">
        <SButton
          type="button"
          class="flex-1"
          :variant="autoScanTickets ? 'default' : 'outline'"
          @click="toggleStatus(true)"
        >
          {{ $t("button.auto") }}
        </SButton>
        <SButton
          type="button"
          class="flex-1"
          :variant="autoScanTickets ? 'outline' : 'default'"
          @click="toggleStatus(false)"
        >
          {{ $t("button.manual") }}
        </SButton>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

// modules
import { useI18n } from "vue-i18n";
import POSConfigModule from "@/store/modules/pos-config";
import { SButton } from "@smeetz/ui-core";

export default defineComponent({
  name: "ScanSettings",
  components: { SButton },
  setup() {
    const autoScanTickets = ref<boolean>(POSConfigModule.getAutoScanTickets);

    const { t } = useI18n({});

    const toggleStatus = (status: boolean) => {
      autoScanTickets.value = status;
    };

    return {
      autoScanTickets,
      toggleStatus,
      t,
    };
  },
});
</script>
